module.exports = __webpack_public_path__ + "static/media/teamsIcon.b66f38ca.png";